// ** React Imports
// import { datadogRum } from '@datadog/browser-rum';
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'


// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'
import { IntlProviderWrapper } from './utility/context/Internationalization'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'
// import TagManager from 'react-gtm-module'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// datadogRum.init({
//   applicationId: '5c3ad529-393f-4193-b201-c589f27e3ae7',
//   clientToken: 'pub5a0038d179039668d6fdf10edd5ebf3e',
//   site: 'datadoghq.com',
//   service: 'coaconference2024',
//   env: 'production', 
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 20,
//   trackUserInteractions: true,
//   trackResources: true,
//   trackLongTasks: true,
//   defaultPrivacyLevel: 'allow',
// });
// import LogRocket from 'logrocket'
// LogRocket.init('hevf9f/coaconference2022')
// ** Lazy load app
const LazyApp = lazy(() => import('./App'))
// const tagManagerArgs = {
//     gtmId: 'GTM-WR3W2T8'
// }
// TagManager.initialize(tagManagerArgs)

// replace console.* for disable log on production
// if (process.env.NODE_ENV === 'production') {
// console.log = () => { }
// console.error = () => {}
// console.debug = () => {}
// }
ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AbilityContext.Provider value={ability}>
        <ThemeContext>
          <IntlProviderWrapper>
            <LazyApp />
            <ToastContainer newestOnTop />
          </IntlProviderWrapper>
        </ThemeContext>
      </AbilityContext.Provider>
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()